export default __webpack_public_path__ + "static/media/photoshop.e560213e.svg";